
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs-cities",
      function () {
        return require("private-next-pages/jobs-cities.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs-cities"])
      });
    }
  